import React from 'react';
import Header from '../../common/header';
import Nav from '../../components/doc-nav';
import s from './index.module.scss';
import {navs_en, navs_zh} from './navs';
import {Redirect, Route, Switch} from 'react-router-dom';
import PermissionApply from '../setting-pages/permission-apply';
import DataPushSetting from '../setting-pages/data-push-setting';
import HelpFeedback from '../setting-pages/help-feedback';
import {connect} from 'react-redux';
import mapStateToProps from '../../redux/util';
import Footer from '../../common/footer';

function Personal(props) {
  const { locale } = props;
  const marginLeft = locale === 'en' ? 320 : 320;
  const navs = locale === 'en' ? navs_en : navs_zh;
  return (
    <div>
      <Header props={ props }/>
      <div className={ s.container }>
        <Nav props={ props } navs={ navs }/>
        <div className={ s.content_wrapper } style={ { marginLeft: marginLeft } }>
          <Switch>
            <Route path="/personal/permissionApply" exact component={ PermissionApply }/>
            <Route path="/personal/dataPushSetting" exact component={ DataPushSetting }/>
            <Route path="/personal/helpFeedback" exact component={ HelpFeedback }/>
            <Redirect to="/personal/permissionApply"/>
          </Switch>
        </div>
      </div>
      <Footer/>
    </div>
  );

}

export default connect(mapStateToProps)(Personal);

